import Model from "./abstract/Model";
import dayjs from "dayjs";

export default class ContractExtension extends Model {
  start_datetime;
  end_datetime;
  reason;
  billed_to;
  name;

  constructor(props) {
    super();
    this.initializeAttributes(props, {
      start_datetime: Date,
      end_datetime: Date
    });
  }

  get note() {
    const date = dayjs(this.start_datetime).format("DD-MM-YYYY HH:mm");
    return (
      `${i18n.database.table.contract_extensions.extended_from} ${date}` +
      (this.signature ? ` (${this.signature})` : "")
    );
  }
}
